import { getContainingComponent } from "ceres/app/helper/utils";

const browserDetect = require("detect-browser");
const NotificationService = require("ceres/app/services/NotificationService");
const AutoFocusService = require("ceres/app/services/AutoFocusService");

import Vue from "vue";
import { getStyle } from "ceres/app/helper/dom";
import { detectPassiveEvents } from "ceres/app/helper/featureDetect";
//import HeaderScroller from "ceres/app/helper/HeaderScroller";

// Frontend end scripts
// eslint-disable-next-line
const headerCollapses = [];

function HeaderCollapse(selector)
{
    headerCollapses.push(selector);
    $(function()
    {
        $(selector).on("show.bs.collapse", () =>
        {
            headerCollapses.forEach(element =>
            {
                if (!$(element).is(selector))
                {
                    $(element).collapse("hide");
                }
            });
        });

    });
}

function CeresMain()
{
    $(document).ready(function()
    {

        if ($(".accordion-widget--hide-xs").length > 0)
        {
            if (window.matchMedia("(max-width: 576px)").matches)
            {
                $(this).find(".accordion-widget__headline").addClass("accordion-widget__headline--is-accordion");
                $(this).find(".accordion-widget__slot").addClass("accordion-widget__slot--hide");

                $(".accordion-widget__slot").click(function(ev)
                {
                    $(this).toggleClass("accordion-widget__slot--hide");
                    $(this).find(".accordion-widget__headline").addClass("accordion-widget__headline--is-open");
                });

            }
        }

        if ($(".accordion-widget--hide-sm").length > 0)
        {
            if (window.matchMedia("(max-width: 768px)").matches)
            {
                $(".accordion-widget--hide-sm").find(".accordion-widget__headline").addClass("accordion-widget__headline--is-accordion");
                $(".accordion-widget--hide-sm").find(".accordion-widget__slot").addClass("accordion-widget__slot--hide");

                $(".accordion-widget--hide-sm .accordion-widget__headline--is-accordion").click(function(ev)
                {
                    $(this).next(".accordion-widget__slot").toggleClass("accordion-widget__slot--hide");
                    $(this).toggleClass("accordion-widget__headline--is-open");
                });
            }
        }

        if ($(".accordion-widget--hide-md").length > 0)
        {
            if (window.matchMedia("(max-width: 992px)").matches)
            {
                $(".accordion-widget--hide-md").find(".accordion-widget__headline").addClass("accordion-widget__headline--is-accordion");
                $(".accordion-widget--hide-md").find(".accordion-widget__slot").addClass("accordion-widget__slot--hide");

                $(".accordion-widget--hide-md .accordion-widget__headline--is-accordion").click(function(ev)
                {
                    $(this).next(".accordion-widget__slot").toggleClass("accordion-widget__slot--hide");
                    $(this).toggleClass("accordion-widget__headline--is-open");
                });
            }
        }

        if ($(".accordion-widget--hide-lg").length > 0)
        {
            if (window.matchMedia("(max-width: 1200px)").matches)
            {
                $(".accordion-widget--hide-lg").find(".accordion-widget__headline").addClass("accordion-widget__headline--is-accordion");
                $(".accordion-widget--hide-lg").find(".accordion-widget__slot").addClass("accordion-widget__slot--hide");

                $(".accordion-widget--hide-lg .accordion-widget__headline--is-accordion").click(function(ev)
                {
                    $(this).next(".accordion-widget__slot").toggleClass("accordion-widget__slot--hide");
                    $(this).toggleClass("accordion-widget__headline--is-open");
                });
            }
        }

        $('.od-show-more-widget__more').on('click', function () {

            let divClass = $(this).attr('show-div');

            $('.' + divClass).toggleClass('open');

            if ($(this).hasClass('od-show-more-widget__more--is-open')) {
                $(this).html('mehr anzeigen');
                $(this).removeClass('od-show-more-widget__more--is-open')
            } else {
                $(this).html('weniger anzeigen');
                $(this).addClass('od-show-more-widget__more--is-open');
            }
        });

        $(".mainmenu__item").mouseover(function()
        {
            $('#page-body').addClass("nav-open");
        });

        $(".mainmenu__item").mouseout(function()
        {
            $('#page-body').removeClass("nav-open");
        });

    });

    const browser = browserDetect.detect();

    if (browser)
    {
        if (browser.name)
        {
            $("html").addClass(browser.name);
        }
        else
        {
            $("html").addClass("unknown-browser");
        }
        if (browser.os)
        {
            $("html").addClass(browser.os.toLowerCase().replace(/[^a-zA-Z0-9\-]/g, "-").replace("windows", "windows windows"));
        }
        else
        {
            $("html").addClass("unknown-os");
        }
    }
    else
    {
        $("html").addClass("unknown-detect");
    }

    $(window).scroll(function()
    {
        if ($(".wrapper-main").hasClass("isSticky"))
        {
            if ($(this).scrollTop() > 1)
            {
                $(".wrapper-main").addClass("sticky");
            }
            else
            {
                $(".wrapper-main").removeClass("sticky");
            }
        }
    });

    window.onpopstate = function(event)
    {
        if (event.state && event.state.requireReload)
        {
            window.location.reload();
        }
    };

    // init bootstrap tooltips
    document.querySelectorAll("[data-toggle=\"tooltip\"]").forEach(el =>
    {
        $(el).tooltip();
    });

    HeaderCollapse("#countrySettings");
    HeaderCollapse("#currencySelect");
    HeaderCollapse("#searchBox");

    const $mainNavbarCollapse = $("#mainNavbarCollapse");

    // prevent hidding collapses in the shopbuilder, for editing search bar results
    if (!App.isShopBuilder)
    {
        $(document).on("click", function(evt)
        {
            headerCollapses.forEach(element =>
            {
                if (evt.target !== element && $(evt.target).parents(element).length <= 0)
                {
                    $(element).collapse("hide");
                }
            });
        });
    }

    $mainNavbarCollapse.collapse("hide");

    // Add click listener outside the navigation to close it
    $mainNavbarCollapse.on("show.bs.collapse", function()
    {
        $(".main").one("click", closeNav);
    });

    $mainNavbarCollapse.on("hide.bs.collapse", function()
    {
        $(".main").off("click", closeNav);
    });

    function closeNav()
    {
        $("#mainNavbarCollapse").collapse("hide");
    }

    $(function()
    {
        const offset = 250;
        const duration = 300;

        let isDesktop = window.matchMedia("(min-width: 768px)").matches;

        AutoFocusService.autoFocus();

        $("#searchBox").on("shown.bs.collapse", function()
        {
            const searchInput = document.querySelector("input.search-input");

            if (searchInput)
            {
                searchInput.focus();
            }
        });

        window.addEventListener("scroll", function()
        {
            if (isDesktop)
            {
                if ($(window).scrollTop() > offset)
                {
                    $(".back-to-top").fadeIn(duration);
                    $(".back-to-top-center").fadeIn(duration);
                }
                else
                {
                    $(".back-to-top").fadeOut(duration);
                    $(".back-to-top-center").fadeOut(duration);
                }
            }
        }, detectPassiveEvents() ? { passive: true } : false );

        window.addEventListener("resize", function()
        {
            isDesktop = window.matchMedia("(min-width: 768px)").matches;
        });

        $(".back-to-top").on("click", function(event)
        {
            event.preventDefault();

            $("html, body").animate({ scrollTop: 0 }, duration);

            return false;
        });

        $(".back-to-top-center").on("click", function(event)
        {
            event.preventDefault();

            $("html, body").animate({ scrollTop: 0 }, duration);

            return false;
        });

        $("#accountMenuList").on("click", function()
        {
            $("#countrySettings").collapse("hide");
            $("#searchBox").collapse("hide");
            $("#currencySelect").collapse("hide");
        });

        $(".ddown").on("keydown", function(event)
        {
            if (event.key === "Space" || event.keyCode === 32)
            {
                event.preventDefault();
                const li = this.closest("li");

                const isOpen = li.classList.toggle("hover");

                this.setAttribute("aria-expanded", isOpen);
            }
        });

        fixPopperZIndexes();

        // Emit event for Sticky Containers to update
        $(".collapse").on("show.bs.collapse hide.bs.collapse", function()
        {
            this.dispatchEvent(new CustomEvent("updateStickyContainer",
                {
                    bubbles: true
                }));
        });
    });
}

window.CeresMain = new CeresMain();
window.CeresNotification = NotificationService;

const showShopNotification = function(event)
{
    if (event.detail.type)
    {
        switch (event.detail.type)
        {
        case "info":
            NotificationService.info(event.detail.message);
            break;
        case "log":
            NotificationService.log(event.detail.message);
            break;
        case "error":
            NotificationService.error(event.detail.message);
            break;
        case "success":
            NotificationService.success(event.detail.message);
            break;
        case "warning":
            NotificationService.warn(event.detail.message);
            break;
        default:
            console.log("no type such as:" + event.detail.type);
            break;
        }
    }
};

document.addEventListener("showShopNotification", showShopNotification);

// fixate the header elements
//new HeaderScroller();

$(document).on("shopbuilder.after.drop shopbuilder.after.widget_replace", function(event, eventData, widgetElement)
{
    const parent = widgetElement[1];

    const parentComponent = getContainingComponent(parent);

    const compiled = Vue.compile(widgetElement[0].outerHTML, { delimiters: ["${", "}"] } );
    const component = new Vue({
        store: window.ceresStore,
        render: compiled.render,
        staticRenderFns: compiled.staticRenderFns,
        parent: parentComponent
    });

    component.$mount( widgetElement[0] );
    $(component.$el).find("*").each(function(index, elem)
    {
        $(elem).on("click", function(event)
        {
            event.preventDefault();
        });
    });

    $(component.$el).find(".owl-carousel").on("resized.owl.carousel", function()
    {
        window.dispatchEvent(new Event("resize"));
    });
});

function fixPopperZIndexes()
{
    const elements = document.querySelectorAll(".popover.d-none");

    let counter = elements.length;

    elements.forEach(el =>
    {
        let zIndex = parseInt(getStyle(el, "z-index"));

        if (!isNaN(zIndex))
        {
            zIndex += --counter;

            el.style.zIndex = zIndex;
        }
    });
}
